import OrdersList from './OrdersList';
import './OrdersList.scss';

export default OrdersList;
